import { render, staticRenderFns } from "./create-task.vue?vue&type=template&id=23251078&scoped=true&"
import script from "./create-task.vue?vue&type=script&lang=js&"
export * from "./create-task.vue?vue&type=script&lang=js&"
import style0 from "./create-task.vue?vue&type=style&index=0&id=23251078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23251078",
  null
  
)

export default component.exports